export default "__VITE_ASSET__CyGaoNjx__"